import type { EventContentObjectDetail } from 'models';
import { Modal } from 'ui';
import { EventInviteesForm } from './event-invitees-form';

type P = {
  className?: string;
  eventContentObject: EventContentObjectDetail;
  isOpened: boolean;
  onClose: () => void;
  onOpenInviteModal?: () => void;
  visuallyHidden?: boolean;
};

const EventInviteesModal = ({
  className,
  eventContentObject,
  isOpened,
  onClose,
  onOpenInviteModal,
  visuallyHidden,
}: P) => (
  <Modal
    className={className}
    isOpened={isOpened}
    maskProps={{
      closable: false,
    }}
    onCancel={() => {
      onClose();
    }}
    title="All invitees"
    visuallyHidden={visuallyHidden}
    width="medium"
  >
    <Modal.ScrollableContent paddingBottom={false} paddingTop={false}>
      <EventInviteesForm eventContentObject={eventContentObject} onOpenInviteModal={onOpenInviteModal} />
    </Modal.ScrollableContent>
  </Modal>
);

export default EventInviteesModal;
